import { type MessageDescriptor } from 'react-intl';

import ChangeAssigneeIconDarkMode from '../../../assets/avatar-with-arrow-darkmode.svg';
import ChangeAssigneeIcon from '../../../assets/avatar-with-arrow.svg';
import RestrictIssueTransitionIconDarkMode from '../../../assets/avatar-with-lock-darkmode.svg';
import RestrictIssueTransitionIcon from '../../../assets/avatar-with-lock.svg';
import UpdateFieldIconDarkMode from '../../../assets/pencilled-field-with-arrow-darkmode.svg';
import UpdateFieldIcon from '../../../assets/pencilled-field-with-arrow.svg';
import CheckFieldValueIconDarkMode from '../../../assets/text-field-with-lock-darkmode.svg';
import CheckFieldValueIcon from '../../../assets/text-field-with-lock.svg';
import ValidateFieldIconDarkMode from '../../../assets/text-field-with-tick-darkmode.svg';
import ValidateFieldIcon from '../../../assets/text-field-with-tick.svg';

import messages from './messages';

export const supportedRules: {
	[key: string]: {
		name: MessageDescriptor;
		ruleType: string;
		icon: { src: string; srcDark: string };
	};
} = {
	['system:change-assignee']: {
		name: messages.changeAssigneeRuleName,
		ruleType: 'Function',
		icon: { src: ChangeAssigneeIcon, srcDark: ChangeAssigneeIconDarkMode },
	},
	['system:check-field-value']: {
		name: messages.checkFieldValueRuleName,
		ruleType: 'Condition',
		icon: { src: CheckFieldValueIcon, srcDark: CheckFieldValueIconDarkMode },
	},
	['system:restrict-issue-transition']: {
		name: messages.restrictIssueTransitionRuleName,
		ruleType: 'Condition',
		icon: { src: RestrictIssueTransitionIcon, srcDark: RestrictIssueTransitionIconDarkMode },
	},
	['system:update-field']: {
		name: messages.updateFieldRuleName,
		ruleType: 'Function',
		icon: { src: UpdateFieldIcon, srcDark: UpdateFieldIconDarkMode },
	},
	['system:validate-field-value']: {
		name: messages.validateFieldRuleName,
		ruleType: 'Validator',
		icon: { src: ValidateFieldIcon, srcDark: ValidateFieldIconDarkMode },
	},
};
